<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/donate"></ion-back-button>
    </ion-buttons>
    <ion-title>About Us</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col sizeLg="6" sizeXl="5" sizeXs="12">
        <ion-img src="https://i.ibb.co/yn7dFhy/Image-Editor.jpg" class="img"></ion-img>
      </ion-col>

      <ion-col sizeLg="6" sizeXl="7" sizeXs="12" class="info-col">
        <div class="info">
          <ion-label class="title">Our Story</ion-label>
          <ion-text class="text">Mimbo began as a tribute to my late dog, Mimbo, who brought endless
            love and joy to my life. After his passing in 2021, I wanted to
            honor his memory in a way that could make a difference. This app is
            my way of honoring him by helping pet parents care for their fur babies
            while supporting animals in need. Mimbo has become a heartfelt
            project celebrating the bond between humans and their
            pets.</ion-text>

          <ion-label class="title"> Our Mission</ion-label>
          <ion-text class="text">Our mission is to be a trusted companion for pet parents, offering
            resources and tools to enhance their pets' well-being and strengthen
            the bond between them. We are also deeply committed to improving the
            lives of stray animals through impactful initiatives and providing
            opportunities for others to get involved and make a difference.
          </ion-text>
          <ion-label class="title"> Our Vision</ion-label>
          <ion-text class="text">
            Our vision is a world where every dog and cat is loved and cared for. We
            strive to support pet parents, help stray animals, and one day open
            our own shelter to provide a safe haven for dogs/cats in need.</ion-text>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid>
    <ion-row>
      <ion-col sizeLg="6" sizeXl="5" sizeXs="12" class="rescues"><ion-img
          src="../../assets/images/rescues.jpg"></ion-img>
      </ion-col>
      <ion-col sizeLg="6" sizeXl="7" sizeXs="12" class="ion-text-center">
        <iframe width="100%" height="560" src="https://www.youtube.com/embed/A0cIlRLbsi8?si=m02CIiQy7VfTALWi"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div></div>
</ion-content>